import { LINK } from '@constants';

export const inquiryKakao = () => {
  const channel = encodeURIComponent('@viewup');

  const intentUrl = `intent://plusfriend/talk/chat/${channel}/#Intent;scheme=kakaoplus;package=com.kakao.talk;end`;

  const checkOpenInApp = window.app?.intent(intentUrl, '');

  if (!checkOpenInApp) window.open(LINK.KAKAO);
};
